import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';

import { Uri } from '#constants/uri';

import type { GetNotificationsResponse } from './types/get-notifications-response.type';

/**
 * Fetches the current user's notification feed.
 *
 * The user is resolved server-side from the secure cookie — no userId is passed.
 * Returns all unread notifications plus a recent bounded set (bounding owned by the server).
 *
 * @param instance - Ky HTTP instance from the application store.
 * @returns OperationResultWithData wrapping `Notification[]`.
 */
export const getNotifications = async (instance: KyInstance): Promise<GetNotificationsResponse> => {
  try {
    return await instance.get<GetNotificationsResponse>(Uri.notifications.base).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
